import Dropdown from './dropdown'
import templateFn from './messages-dropdown.ejs'
import { PeopleAndOrgsLoader } from '../lib/people-and-orgs-loader'

class MessagesDropdown extends Dropdown {

  constructor(options) {
    super(options)
    this.templateFn = templateFn
    this.loader = new PeopleAndOrgsLoader()
    this.closeOnIframeFocus = false
  }

  async init() {
    super.init()
    await this.loader.loadMessagesDropdown()
    if (this.$messagesDropdown) this.wireMessagesDropdown()
    else this.once('render', this.wireMessagesDropdown.bind(this))
  }

  wireMessagesDropdown() {
    this.$messagesDropdown.addEventListener('closeMenu', () => this.close())
  }

  open() {
    if (this.active) return
    super.open()
    this.refreshMessages()
  }

  refreshMessages() {
    this.$messagesDropdown.dispatchEvent(new Event('refreshMessages'))
  }
}

export default MessagesDropdown
